<template>
  <a-layout class='s_bf'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='gift_name'>
          <a-input v-model:value="search.gift_name" style="width:250px;margin-bottom: 15px;" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="礼品分类">
             <a-select v-model:value="search.gift_type" style="width:140px" placeholder="请选择分类">
                 <a-select-option :value="item.id" v-for="(item,index) in classificationList" :key="index">{{item.name}}</a-select-option>
             </a-select>
        </a-form-item>
        <a-form-item >
            <a-button @click="pageSearchChange" type="primary">搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='gift_id' :columns='columns' :data-source='data'>
        <template v-slot:info="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+record.image_url" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.gift_name}}</template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
              <a-button type="primary" @click='choose(record)' :ghost="!record.select" v-if="!record.select">选择</a-button>
              <a-button type="primary" @click='cancle(record)' :ghost="!record.select" v-else>已选择</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" />
      <!-- <div class="s_flex_center m-t-25" v-if='checkout'>
        <a-button type="primary" @click='confirm'>确定</a-button>
      </div> -->
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { useTree } from '@/hooks/useTree.js'
  import {
    getGiftSkuList,
    getGiftCate
  } from "@/api/product";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    gift_name: "",
    page: 1,
    limit: 5,
    gift_id:null
  };
  export default {
    name: "selectBaseGiftSku",
    props: {
    //   checkout: Boolean,
      selectList: {
        type: Array
      },
      max:{
        type:Number,
        default:()=>{
          return 999999
        }
      }
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref();
      search.value = { ...defSearch }
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        checkbox: [],
        listLoading: false,
        time: [],
        total: 1,
        classificationList: [],
        status: 1,
        selectList: [],//被选中的列表
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "gift_id",
          key: "gift_id"
        },
        {
          title: "礼品信息",
          dataIndex: "info",
          key: "info",
          slots: { customRender: "info" }
        },
        {
          title: "规格",
          dataIndex: "spec_value",
          key: "spec_value"
        },
        // {
        //   title: "礼品类型",
        //   dataIndex: "gift_type_name",
        //   key: "gift_type_name"
        // },
        {
          title: "分类",
          dataIndex: "category_name",
          key: "category_name"
        },
        {
          title: "价格",
          dataIndex: "market_price",
          key: "market_price"
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 获取分类
      const initCate = async () => {
        let result = await getGiftCate().then((res) => res.data);
        // state.loadData = useTree(result.data);
        // state.loadData.map((v) => (v.disabled = v.child.length == 0 ? true : false));
        console.log(result)
        if(iscode(result)){
            state.classificationList = result.data || [];
        }else{
            message.error(result.msg)
        }
      };
      const form = ref();
      const reset = () => {
        search.value = defSearch
        form.value.resetFields()
        state.checkbox = []
        search.value.ex_gift_cate_id = ""
      };
      const initData = async (values) => {
        var json = JSON.parse(JSON.stringify(search.value))
        for (var i = 0; i < state.checkbox.length; i++) {
          json[state.checkbox[i]] = 1
        }
        state.listLoading = true;
        let res = await getGiftSkuList(search.value).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          
          if (state.selectList.length > 0) {
            data.value.forEach(i => {
              if (state.selectList.find(v => i.gift_id+i.sku_number == v.gift_id+v.sku_number)) {
                i.select = true
              }
            })
          }
        } else {
          message.error(res.msg);
        }
      };

      //单选
      const select = (e) => {
        e.select = !e.select
        emit("select", e);
      }
   
      //多选
      const checkBnt = (e) => {
        if(props.max<=state.selectList.length){return message.error(`最多选择${props.max}件商品`)}
        if (!e.select) {
          state.selectList.push(e);
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.gift_id+v.sku_number == e.gift_id+e.sku_number) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select
      }   
      const cancle=(data)=>{
         var index=0
          state.selectList.forEach((v, k) => {
            if (v.gift_id+v.sku_number == data.gift_id+data.sku_number) {
              index = k;

            }
          });
           data.select = !data.select
          state.selectList.splice(index, 1);
      }
    //   //多选确认
    //   const confirm = () => {
    //     emit("select", state.selectList);
    //   }
      const choose = (e) => {
        // if (props.checkout) {
        //   checkBnt(e)
        // } else {
        //   select(e)
        // }
        select(e)
      }
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
        }
        initData(search.value);
        initCate();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        // confirm,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        reset,
        form,
        choose,
        cancle
      };
    },
  };
</script>